import React, { Component } from "react";
// CUSTOM
import "./AttributeTable.scss";
import * as helpers from "./helpers";
import * as vHelpers from "./vHelpers";
import {
  FeatureHelpers,
  LayerHelpers,
  OL_DATA_TYPES,
} from "../../src/helpers/OLHelpers.js";

// COMPONENTS
import AttributeTableTabs from "./AttributeTableTabs.jsx";
import FloatingMenu, { FloatingMenuItem } from "../helpers/FloatingMenu.jsx";
import Portal from "../helpers/Portal.jsx";
import ReactDOM from "react-dom";
import { Resizable } from "re-resizable";
import { Item as MenuItem } from "rc-menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
// import LoadingScreen from "../helpers/LoadingScreen.jsx";

// functions: open att table, save item to array in window, show result as feature
class AttrbuteTable extends Component {
  constructor(props) {
    super(props);

    this.numRecordsToPull = 200;
    this.storageKeyFilterResults = window.config.storageKeyFilterResults;

    this.state = {
      tabIndex: 0,
      usedFilterNames: [],
      visible: false,
      items: [],
      savedItems: [],
      mapWidth: 100,
      height: 0,
      isLoading: false,
    };

    // LISTEN ATT TABLE CHANGES
    window.emitter.addListener(
      "openAttTab",
      (
        serverUrl,
        layerName,
        cqlFilter,
        name,
        checkbox,
        id,
        source,
        alias,
        render
      ) =>
        this.openAttTab(
          serverUrl,
          layerName,
          cqlFilter,
          name,
          checkbox,
          id,
          source,
          alias,
          render
        )
    );
    window.emitter.addListener(
      "openAttTabGEOJSON",
      (name, geojson, id, source, layername, query, checkbox) =>
        this.openAttTabGEOJSON(
          name,
          geojson,
          id,
          source,
          layername,
          query,
          checkbox
        )
    );
    window.emitter.addListener(
      "openAttTab_extWFS",
      (url, layerName, xmlFilter, name, checkbox, id, source, alias) =>
        this.openAttTab_extWFS(
          url,
          layerName,
          xmlFilter,
          name,
          checkbox,
          id,
          source,
          alias
        )
    );
    window.emitter.addListener("closeAttTab", (name) => this.onTabClose(name));
    window.emitter.addListener("onTabClick", (e, reRender) =>
      this.onTabClick(e, reRender)
    );
    window.emitter.addListener("addTableRow", (tabName, layerName, id, fid) =>
      this.addTableRow(tabName, layerName, id, fid)
    );
    window.emitter.addListener("mapParametersComplete", () => this.onMapLoad());
    window.emitter.addListener("mapResize", () => this.onMapResize());
    window.emitter.addListener("resetSavedItems", () => this.resetSavedItems());
    window.isAttributeTableResizing = false;
  }

  componentDidUpdate(prevState) {
    if (prevState.savedItems !== this.state.savedItems) {
      window.filterResults = this.state.savedItems;
      window.emitter.emit("setPreviousResults");
      // window.dispatchEvent(new Event("filterResultsChanged"));
    }
    if (prevState.items !== this.state.items) {
      window.items = this.state.items;
    }
  }

  componentDidMount() {
    window.activeTabIndex = 0;
  }

  resetSavedItems = () => {
    this.setState({ savedItems: window.filterResults });
  };

  onMapResize = () => {
    this.resizeFromMap();
  };

  onMapLoad = () => {
    this.resizeFromMap();
    window.emitter.emit("attributeTableResize", this.state.height);
  };

  resizeFromMap = () => {
    const mapWidth = document.getElementById("map").offsetWidth;
    this.resizable.updateSize({
      width: mapWidth,
      height: this.resizable.resizable.offsetHeight,
    });
    this.setState({
      mapWidth: mapWidth - 65,
      height: this.resizable.resizable.offsetHeight,
    });
  };

  openAttTab = (
    serverUrl,
    layerName,
    cqlFilter,
    name,
    checkbox,
    id,
    source,
    alias,
    render
  ) => {
    window.emitter.emit("mapLoading");
    const item = {
      name: name,
      layerName: layerName,
      geoJson: [],
      serverUrl: serverUrl,
      cqlFilter: cqlFilter,
      maxRecords: this.numRecordsToPull,
      sortFields: "",
      scrollTop: 0,
      id: id,
      layerSource: source,
      alias: alias,
    };
    this.getData_longGeometry(checkbox, item, render, (item) => { });
  };

  getData_longGeometry = (checkbox, item, render, callback) => {
    this.setState({ isLoading: true }, () => {
      console.log("item: " + item.cqlFilter);
      vHelpers.postLongGeometry(
        item.layerName,
        item.cqlFilter,
        item.id,
        item.sortFields,
        item.maxRecords,
        (result) => {
          if (result.length !== 0) {
            // if (render === true) vHelpers.renderFeature(item, "filter", true);
            // window.emitter.emit(
            //   "renderFeature",
            //   result,
            //   prevResult.layerName,
            //   prevResult.name,
            //   prevResult.name,
            //   "prevRes",
            //   true,
            //   "0, 172, 166"
            // );

            if (item.id === undefined && result.length <= 100) {
              let array_of_id = [];
              item.id = result.map((res) => {
                array_of_id.push(res.id_);
              });
              item.id = array_of_id.join(",").toString().replace(/\s+/g, "");
            }
            // ATTACH GEOJSON
            item.geoJson = result;

            helpers.getWFSLayerRecordCount_post(
              item.serverUrl,
              item.layerName,
              item.cqlFilter,
              item.id,
              (count) => {
                item.total = count;
                let itemFound = this.getItemByname(item.name);
                const isVisible = this.state.visible;
                if (itemFound === undefined) {
                  this.setState(
                    (prevState) => ({
                      visible: true,
                      items: [item, ...prevState.items],
                      isLoading: false,
                    }),
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                    }
                  );
                  if (checkbox) {
                    this.setState((prevState) => ({
                      savedItems: [item, ...prevState.savedItems],
                    }));
                    window.emitter.emit("setPreviousResults");
                  }
                } else {
                  this.setState(
                    {
                      items: this.state.items.map((stateItem) =>
                        stateItem.name === item.name
                          ? Object.assign({}, stateItem, { geoJson: result })
                          : stateItem
                      ),
                      isLoading: false,
                    },
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                    }
                  );
                }
              }
            );
          } else {
            const isVisible = this.state.visible;
            this.setState(
              (prevState) => ({
                visible: true,
                isLoading: false,
              }),
              () => {
                if (!isVisible) {
                  this.updateSize();
                }
              }
            );
            helpers.showMessage(
              "Oznámenie",
              "Neboli nájdené žiadne výsledky",
              helpers.messageColors.gray,
              5000,
            );
            return;
          }
        }
      );
    });
    setTimeout(function () {
      window.emitter.emit("onTabClick", item.name, render);
      window.emitter.emit("stopLoading");
      window.emitter.emit("mapLoaded");
    }, 500);
  };

  openAttTabGEOJSON = (
    name,
    geojson,
    id,
    source,
    layername,
    query,
    checkbox
  ) => {
    console.log("openAttTabGEOJSON", {
      name,
      geojson,
      id,
      source,
      layername,
      query,
      checkbox,
    });
    const tableIsOpen = this.state.items.some((obj) => obj.name === name);
    const geoJson = Array.isArray(geojson) ? geojson : [geojson];

    if (!tableIsOpen) {
      const item = {
        name: name,
        tabName: name,
        layername: layername,
        query: query,
        geoJson: geoJson,
        id: id,
        layerSource: source,
      };
      const isVisible = this.state.visible;
      this.setState(
        (prevState) => ({
          visible: true,
          items: [item, ...prevState.items],
          isLoading: false,
        }),
        () => {
          window.emitter.emit("onTabClick", name, false);
          if (!isVisible) {
            this.updateSize();
          }
        }
      );
      if (checkbox) {
        this.setState((prevState) => ({
          savedItems: [item, ...prevState.savedItems],
        }), () => {
          helpers.showMessage(
            "Oznámenie",
            "Vybraný objekt je teraz dostupný v Manažmente výsledkov.",
            helpers.messageColors.green,
            5000,
          );
        });
        window.emitter.emit("setPreviousResults");
      }
    } else {
      window.emitter.emit("onTabClick", name, false);

      // if (checkbox) {
      //   console.log("ok, tu som");

      //   const item = {
      //     name: name,
      //     tabName: name,
      //     layername: layername,
      //     query: query,
      //     geoJson: geoJson,
      //     id: id,
      //     layerSource: source,
      //   };

      //   this.setState((prevState) => ({
      //     savedItems: [item, ...prevState.savedItems],
      //   }), () => {
      //     helpers.showMessage(
      //       "Oznámenie",
      //       "Vybraný objekt je teraz dostupný v Manažmente výsledkov.",
      //       helpers.messageColors.green,
      //       5000,
      //     );
      //   });
      //   window.emitter.emit("setPreviousResults");
      // }
    }
  };

  openAttTab_extWFS = (
    url,
    layerName,
    xmlFilter,
    name,
    checkbox,
    id,
    source,
    alias
  ) => {
    console.log("openAttTab_extWFS");
    const item = {
      name: name,
      layerName: layerName,
      geoJson: [],
      url: url,
      xmlFilter: xmlFilter,
      maxRecords: this.numRecordsToPull,
      sortFields: "",
      scrollTop: 0,
      id: id,
      layerSource: source,
      alias: alias,
    };
    this.getData_ext(checkbox, item, (item) => { });
  };

  addLayer = (layer) => {
    let showLayer = true; // this.state.tabIndex !== 0;
    let styleUrl = "";
    // let queryable = false;
    // layer created from uploaded file will be loaded as VectorLayer, set it to queryable
    // allows the condition checking (source = 'file') in LayerHelpers.getLayer() to load
    // data from this layer such that identify tool will work

    let queryable =
      LayerHelpers.getLayerSourceType(layer.getSource()) ===
        OL_DATA_TYPES.Vector
        ? true
        : false;
    let opaque = false;
    let infoFormat = "";
    let xslTemplate = "";
    if (this.state.selectLayerOption !== this.defaultLayerOption) {
      const selectedLayer = this.state.selectLayerOptions.filter(
        (item) => item.value === this.state.selectLayerOption.value
      )[0];
      if (selectedLayer !== undefined) {
        if (selectedLayer.style !== undefined) styleUrl = selectedLayer.style;
        if (selectedLayer.queryable !== undefined)
          queryable = selectedLayer.queryable;
        if (selectedLayer.opaque !== undefined) opaque = selectedLayer.opaque;
        if (selectedLayer.INFO_FORMAT !== undefined)
          infoFormat = selectedLayer.INFO_FORMAT;
        if (selectedLayer.XSL_TEMPLATE !== undefined)
          xslTemplate = selectedLayer.XSL_TEMPLATE;
      }
    }

    layer.setVisible(true);
    layer.setOpacity(1);
    /*newLayer.setProperties({ name: layerNameOnly, 
                                    displayName: displayName,
                                    wfsUrl: wfsUrl, 
                                    rootInfoUrl: rootInfoUrl, 
                                    disableParcelClick: liveLayer,
                                    queryable:queryable,
                                    opaque:opaque  });*/

    layer.setProperties({
      name: this.state.layer_name,
      displayName: this.state.layer_displayName,
      tocDisplayName: this.state.layer_displayName,
      //disableParcelClick: queryable,
      userLayer: true,
      queryable: queryable,
      opaque: opaque,
      INFO_FORMAT: infoFormat,
      XSL_TEMPLATE: xslTemplate,
    });
    const newLayer = {
      name: this.state.layer_name, // FRIENDLY NAME
      tocDisplayName: this.state.layer_displayName,
      height: 30, // HEIGHT OF DOM ROW FOR AUTOSIZER
      drawIndex: undefined, // INDEX USED BY VIRTUAL LIST
      index: undefined, // INDEX USED BY VIRTUAL LIST
      styleUrl: styleUrl, // WMS URL TO LEGEND SWATCH IMAGE
      showLegend: false, // SHOW LEGEND USING PLUS-MINUS IN TOC
      legendHeight: -1, // HEIGHT OF IMAGE USED BY AUTOSIZER
      legendImage: null, // IMAGE DATA, STORED ONCE USER VIEWS LEGEND
      visible: true, // LAYER VISIBLE IN MAP, UPDATED BY CHECKBOX
      layer: layer, // OL LAYER OBJECT
      metadataUrl: null, // ROOT LAYER INFO FROM GROUP END POINT
      opacity: 1.0, // OPACITY OF LAYER
      minScale: undefined, //MinScaleDenominator from geoserver
      maxScale: undefined, //MaxScaleDenominator from geoserver
      liveLayer: styleUrl === "" ? false : true, // LIVE LAYER FLAG
      wfsUrl: "",
      userLayer: true,
      queryable: queryable,
      displayName: this.state.layer_displayName,
      canDownload: false,
      group: "",
      groupName: "",
      infoFormat: infoFormat,
      xslTemplate: xslTemplate,
    };
    // this.addCustomLayer(newLayer, undefined, showLayer, true);
    // setTimeout(() => {
    //   this.clearLayers();
    // }, 500);
  };
  //   addCustomLayer = (layer) => {
  //     console.log("nova vrstva", layer)
  //     let layerIndex = 100;
  //     TOCHelpers.makeLayer(
  //       layer.displayName,
  //       helpers.getUID(),
  //       layersGroup,
  //       layerIndex,
  //       true,
  //       1,
  //       layer.layer,
  //       undefined,
  //       undefined,
  //       false,
  //       layer.styleUrl,
  //       (retLayer) => {
  //         let layers = layersGroup.layers;
  //         layers.unshift(retLayer);
  //       }
  //     );
  //   };

  getData_ext = (checkbox, item, callback) => {
    console.log("in getData_longGeometry EXT", item);

    this.setState({ isLoading: true }, () => {
      helpers.getExtWFSGeoJSON(
        item.url,
        item.layerName,
        item.xmlFilter,
        item.id,
        item.sortFields,
        null,
        item.maxRecords,
        "GEOJSON",
        (result) => {
          const mapProjection = window.map.getView().getProjection();
          // let feature = FeatureHelpers.setFeatures(
          //   result,
          //   OL_DATA_TYPES.GeoJSON,
          //   "EPSG:5514",
          //   "EPSG:5514"
          // );
          let feature = FeatureHelpers.setFeatures([result], OL_DATA_TYPES.GeoJSON, "EPSG:5514", "EPSG:5514");

          if (feature !== undefined) {
            feature = JSON.parse(feature);
            feature.crs = {
              type: "name",
              properties: {
                name: "urn:ogc:def:crs:EPSG::5514",
              },
            };
            // itemLayer.geom = feature;
            // if (itemLayer.geom.features[0].properties.labelVisible) {
            //     itemLayer.type = "gjsonlabel";
            // }

            // /*itemLayer.geom = feature.features.map((item) => {
            //     if (item.properties === null) item.properties = {};
            //     return item;
            // });*/
            // returnLayers.push(itemLayer);
          }

          //               _this.addFeatures(
          //     featureParser.readFeatures(response, {
          //       dataProjection:
          //         featureParser.readProjection(response) || projection,
          //       featureProjection: mapProjection,
          //     })
          //   );

          if (result.length !== 0) {
            // vHelpers.renderFeature(item, "filter", true);
            window.emitter.emit(
              "renderFeature",
              result,
              // feature.features,
              item.layerName,
              item.layerName,
              item.layerName,
              "filter",
              true,
            );
            if (item.id === undefined && result.length <= 100) {
              let array_of_id = [];
              item.id = result.map((res) => {
                array_of_id.push(res.id_);
              });
              item.id = array_of_id.join(",").toString().replace(/\s+/g, "");
            }
            // ATTACH GEOJSON
            item.geoJson = result;

            helpers.getExtWFSLayerRecordCount(
              item.url,
              item.layerName,
              item.xmlFilter,
              //   item.id,
              (count) => {
                item.total = count;
                let itemFound = this.getItemByname(item.name);
                const isVisible = this.state.visible;
                if (itemFound === undefined) {
                  this.setState(
                    (prevState) => ({
                      visible: true,
                      items: [item, ...prevState.items],
                      isLoading: false,
                    }),
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                    }
                  );
                  if (checkbox) {
                    this.setState((prevState) => ({
                      savedItems: [item, ...prevState.savedItems],
                    }));
                    window.emitter.emit("setPreviousResults");
                  }
                } else {
                  this.setState(
                    {
                      items: this.state.items.map((stateItem) =>
                        stateItem.name === item.name
                          ? Object.assign({}, stateItem, { geoJson: result })
                          : stateItem
                      ),
                      isLoading: false,
                    },
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                    }
                  );
                }
              }
            );
          } else {
            const isVisible = this.state.visible;
            this.setState(
              (prevState) => ({
                visible: true,
                isLoading: false,
              }),
              () => {
                if (!isVisible) {
                  this.updateSize();
                }
              }
            );
            helpers.showMessage(
              "Oznámenie",
              "Neboli nájdené žiadne výsledky",
              helpers.messageColors.gray,
              5000,
            );
            return;
          }
        }
      );
    });
    setTimeout(function () {
      //   window.emitter.emit("onTabClick", item.name, true);
      window.emitter.emit("stopLoading");
    }, 500);
  };

  //   getData_longGeometry = (checkbox, item, callback) => {
  //     console.log("in getData_longGeometry");
  //     this.setState({ isLoading: true }, () => {
  //       vHelpers.postLongGeometry(
  //         item.layerName,
  //         item.cqlFilter,
  //         item.id,
  //         item.sortFields,
  //         item.maxRecords,
  //         (result) => {
  //           console.log("layerName", item.layerName);
  //           console.log("cqlFilter", item.cqlFilter);
  //           console.log("id", item.id);
  //           console.log("sortFields", item.sortFields);
  //           console.log("maxRecords", item.maxRecords);
  //           console.log("result", result);
  //           if (result.length !== 0) {
  //             vHelpers.renderFeature(item, "filter", true);

  //             if (item.id === undefined && result.length <= 100) {
  //               let array_of_id = [];
  //               item.id = result.map((res) => {
  //                 array_of_id.push(res.id_);
  //               });
  //               item.id = array_of_id.join(",").toString().replace(/\s+/g, "");
  //             }
  //             // ATTACH GEOJSON
  //             item.geoJson = result;

  //             helpers.getWFSLayerRecordCount_post(
  //               item.serverUrl,
  //               item.layerName,
  //               item.cqlFilter,
  //               item.id,
  //               (count) => {
  //                 item.total = count;
  //                 let itemFound = this.getItemByname(item.name);
  //                 const isVisible = this.state.visible;
  //                 if (itemFound === undefined) {
  //                   this.setState(
  //                     (prevState) => ({
  //                       visible: true,
  //                       items: [item, ...prevState.items],
  //                       isLoading: false,
  //                     }),
  //                     () => {
  //                       if (!isVisible) {
  //                         this.updateSize();
  //                       }
  //                     }
  //                   );
  //                   if (checkbox) {
  //                     this.setState((prevState) => ({
  //                       savedItems: [item, ...prevState.savedItems],
  //                     }));
  //                     window.emitter.emit("setPreviousResults");
  //                   }
  //                 } else {
  //                   this.setState(
  //                     {
  //                       items: this.state.items.map((stateItem) =>
  //                         stateItem.name === item.name
  //                           ? Object.assign({}, stateItem, { geoJson: result })
  //                           : stateItem
  //                       ),
  //                       isLoading: false,
  //                     },
  //                     () => {
  //                       if (!isVisible) {
  //                         this.updateSize();
  //                       }
  //                     }
  //                   );
  //                 }
  //               }
  //             );
  //           } else {
  //             const isVisible = this.state.visible;
  //             this.setState(
  //               (prevState) => ({
  //                 visible: true,
  //                 isLoading: false,
  //               }),
  //               () => {
  //                 if (!isVisible) {
  //                   this.updateSize();
  //                 }
  //               }
  //             );
  //             alert("Výsledok filtrovania je prázdny!");
  //             return;
  //           }
  //         }
  //       );
  //     });
  //     setTimeout(function () {
  //       window.emitter.emit("onTabClick", item.name, true);
  //       window.emitter.emit("stopLoading");
  //     }, 500);
  //   };

  scrollBottom = () => {
    const tableID = this.state.items[this.state.tabIndex]["alias"]
      ? "sc-attribute-table-tab-" +
      this.state.items[this.state.tabIndex]["alias"]
      : "sc-attribute-table-tab-" +
      this.state.items[this.state.tabIndex]["name"];
    const container = document.getElementById(tableID);
    const tableContent = container.getElementsByClassName(
      "sc-attribute-table-row-content"
    );
    const element = tableContent[0].lastChild;

    const scrollPosition = element.offsetTop - container.offsetTop - 500;
    container.scrollTo({ top: scrollPosition, behavior: "smooth" });
  };

  getTable_longGeometry = (checkbox, item, callback) => {
    this.setState({ isLoading: true }, () => {
      vHelpers.postLongGeometry(
        item.layerName,
        item.cqlFilter,
        item.id,
        item.sortFields,
        item.maxRecords,
        (result) => {
          if (result.length !== 0) {
            if (item.id === undefined && result.length <= 100) {
              let array_of_id = [];
              item.id = result.map((res) => {
                array_of_id.push(res.id_);
              });
              item.id = array_of_id.join(",").toString().replace(/\s+/g, "");
            }
            // ATTACH GEOJSON
            item.geoJson = result;

            helpers.getWFSLayerRecordCount_post(
              item.serverUrl,
              item.layerName,
              item.cqlFilter,
              item.id,
              (count) => {
                item.total = count;
                let itemFound = this.getItemByname(item.name);
                const isVisible = this.state.visible;
                if (itemFound === undefined) {
                  this.setState(
                    (prevState) => ({
                      visible: true,
                      items: [item, ...prevState.items],
                      isLoading: false,
                    }),
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                    }
                  );
                  if (checkbox) {
                    this.setState((prevState) => ({
                      savedItems: [item, ...prevState.savedItems],
                    }));
                    window.emitter.emit("setPreviousResults");
                  }
                } else {
                  this.setState(
                    {
                      // UPDATE ITEMS
                      items: this.state.items.map((stateItem) =>
                        stateItem.name === item.name
                          ? Object.assign({}, stateItem, { geoJson: result })
                          : stateItem
                      ),
                      isLoading: false,
                    },
                    () => {
                      if (!isVisible) {
                        this.updateSize();
                      }
                      this.scrollBottom();
                    }
                  );
                }
              }
            );
          } else {
            const isVisible = this.state.visible;
            this.setState(
              (prevState) => ({
                visible: true,
                isLoading: false,
              }),
              () => {
                if (!isVisible) {
                  this.updateSize();
                }
              }
            );
            helpers.showMessage(
              "Oznámenie",
              "Neboli nájdené žiadne výsledky",
              helpers.messageColors.gray,
              5000,
            );
            return;
          }
        }
      );
    });
  };

  addTableRow = (tabName, layerName, id, fid, callback) => {
    this.setState({ isLoading: true }, () => {
      if (fid === undefined) {
        helpers.getWFSGeoJSON(
          window.config.geoserverUrl,
          layerName,
          (result) => {
            if (result.length === 0) return;

            let alItems = this.state.items;
            const itemIndex = alItems.findIndex((object) => {
              return object.alias
              ? object.alias === tabName
                : object.name === tabName;
              });
            const previousFeatures = alItems[itemIndex]["geoJson"];
            const bindFeatures = [result[0], ...previousFeatures];
            alItems[itemIndex]["geoJson"] = bindFeatures;

            this.setState((prevState) => ({
              visible: true,
              items: alItems,
              isLoading: false,
            }));
          },
          null,
          null,
          null,
          null,
          id
        );
      } else {
        helpers.getWFSGeoJSON(
          window.config.geoserverUrl,
          layerName,
          (result) => {
            if (result.length === 0) return;

            let alItems = this.state.items;
            const itemIndex = alItems.findIndex((object) => {
              return object.name === tabName;
            });

            const previousFeatures = alItems[itemIndex]["geoJson"];
            const bindFeatures = [result[0], ...previousFeatures];
            alItems[itemIndex]["geoJson"] = bindFeatures;

            this.setState((prevState) => ({
              visible: true,
              items: alItems,
              isLoading: false,
            }));
          },
          null,
          null,
          "vfid=" + fid, //cql
          null,
          null
        );
      }
    });
  };

  updateSize = () => {
    const mapWidth = document.getElementById("map").offsetWidth;
    this.resizable.updateSize({ width: mapWidth, height: 200 });
    this.setState({ mapWidth: mapWidth, height: 200 });
    window.emitter.emit("attributeTableResize", 200);
  };

  getItemByname = (name) => {
    let item = this.state.items.filter((item) => {
      return item.name === name || item.alias === name;
    })[0];
    return item;
  };

  onResize = (e, direction, ref, d) => {
    // window.emitter.emit("attributeTableResize", ref.offsetHeight);
    this.setState({ height: ref.offsetHeight });
  };

  onResizeStart = (e, direction, ref, d) => {
    window.isAttributeTableResizing = true;
  };

  onResizeStop = (e, direction, ref, d) => {
    window.isAttributeTableResizing = false;
    window.emitter.emit("attributeTableResize", ref.offsetHeight);
  };

  onTabClick = (e, reRender = true) => {
    let index = typeof e === "string" ? this.state.items.findIndex((item) => item.name === e) : e;
    if (index < 0) return;
  
    const currentTab = this.state.items[index];
    const tabName = currentTab.alias ? currentTab.alias : currentTab.name;
  
    if (reRender) {
      // Odstránenie vrstiev len pre taby, ktoré už nie sú otvorené
      const activeTabNames = this.state.items.map((item) => item.alias || item.name);
      const layers = window.map.getLayers().getArray();
  
      layers.forEach((layer) => {
        const layerName = layer.get("name");
        if (layerName && !activeTabNames.some((name) => layerName.startsWith(name))) {
          console.log(`Removing unused layer: ${layerName}`);
          window.map.removeLayer(layer); // Odstráni len nepoužívané vrstvy
        }
      });
  
      // Renderovanie aktuálneho tabu
      currentTab.geoJson.forEach((feature, rowIndex) => {
        const checkboxLayerName = `${tabName}-checkbox-${rowIndex}`;
        window.emitter.emit("renderFeature", feature, checkboxLayerName);
      });
    }
  
    this.setState({ tabIndex: index });
  };
  
  // onTabClick = (e, reRender = true) => {
  //   console.log("onTabClick", e);
  //   let index = "";
  //   if (typeof e === "string") {
  //     index = this.state.items.findIndex((object) => {
  //       return object.name === e;
  //     });
  //   } else {
  //     index = e;
  //   }
  //   if (index === null) index = 0;
  //   if (index < 0) return;

  //   this.setState({ tabIndex: index });
  //   const currentActiveTabIndex = window.activeTabIndex;
  //   if (currentActiveTabIndex !== undefined) {
  //     window.activeTabIndex = index;
  //     const item = this.state.items[index];
  //     const isFromURI = item.layerSource === "uri";
  //     const isFromKN = item.layerSource === "kn";
  //     if ((item.geoJson.length === undefined) || (item.length === 0) || (item.layerSource === "lv")) return;
  //     if (reRender) {
  //       const layers = window.map.getLayers().getArray();
  //       const existLayer = layers.filter(
  //         (layer) => layer?.get("name") === item.name
  //       );
  
  //       if (existLayer.length === 0) {
  //         // Odstránenie všetkých vrstiev obsahujúcich "checkbox" v názve
  //         layers.forEach((layer) => {
  //           const layerName = layer.get("name");
  //           if (layerName && layerName.includes("checkbox")) {
  //             console.log(`Removing layer: ${layerName}`);
  //             window.map.removeLayer(layer); // Odstráni vrstvu z mapy
  //           }
  //         });
  
  //         window.emitter.emit("removeRenderedFeature", "bothBySource", null, "filter");
  //         window.emitter.emit("removeRenderedFeature", "bothBySource", null, "uri");
  //         window.emitter.emit("removeRenderedFeature", "bothBySource", null, "kn");
  //         window.emitter.emit("removeRenderedFeature", "bothBySource", null, "hmsp");
  //         window.emitter.emit("removeRenderedFeature", "allHighlights");
  //         window.emitter.emit("removeRenderedFeature", "checkbox-layer");
  //         window.emitter.emit("closePopup");
  
  //         // if (isFromURI) {
  //         //   const feature = item.geoJson;
  //         //   window.emitter.emit(
  //         //     "renderFeature",
  //         //     feature,
  //         //     item.tabName,
  //         //     item.tabName,
  //         //     feature.ol_uid,
  //         //     "uri",
  //         //     true
  //         //   );
  
  //         // } else if (isFromKN) {
  //         //   window.emitter.emit(
  //         //     "renderFeature",
  //         //     item.geoJson,
  //         //     item.tabName,
  //         //     item.tabName,
  //         //     item.id,
  //         //     item.layerSource,
  //         //     true
  //         //   );
  
  //         // } else {
  //         //   vHelpers.renderFeature(item, "filter", true);
  //         // }
  //       }
  //     }
  //   }
  // };


  onTabClose = (name) => {
    this.state.items.forEach((item) => {
      const tabName = item.alias ? item.alias : item.name;
      if (tabName === name) {
        // Odstránenie len vrstiev patriacich k uzatváranému tabu
        window.emitter.emit("removeRenderedFeature", "bothByLayerName", tabName);
        item.geoJson.forEach((_, rowIndex) => {
          const checkboxLayerName = `${tabName}-checkbox-${rowIndex}`;
          window.emitter.emit("removeRenderedFeature", "bothByLayerName", checkboxLayerName);
        });
  
        // Čistenie stavov checkboxov
        if (this.attributeTableTabsRef) {
          this.attributeTableTabsRef.clearCheckboxStatesForTab(tabName);
        }
  
        const closedTabIndex = this.state.items.findIndex(
          (e) => (e.alias ? e.alias : e.name) === name
        );
  
        const newActiveTabIndex =
          closedTabIndex === this.state.items.length - 1
            ? closedTabIndex - 1
            : closedTabIndex;
  
        this.setState(
          {
            items: this.state.items.filter((item) => {
              const itemName = item.alias ? item.alias : item.name;
              return tabName !== itemName;
            }),
          },
          () => {
            window.disableParcelClick = false;
            if (this.state.items.length === 0) {
              this.setState({ visible: false });
              window.emitter.emit("attributeTableResize", 0);
            } else {
              this.onTabClick(newActiveTabIndex, false); // Žiadne mazanie vrstiev pri zatváraní
            }
          }
        );
      }
    });
  };
  
  // onTabClose = (name) => {
  //   this.state.items.map((item) => {
  //     const tabName = item.alias ? item.alias : item.name;
      
  //     console.log("onTabClose", tabName, name);

  //     if (tabName === name) {
  //       // Odstránenie hlavnej vrstvy tabu
  //       window.emitter.emit("removeRenderedFeature", "bothByLayerName", tabName, undefined);
  //       window.emitter.emit("removeRenderedFeature", "allHighlights");
  //       window.popup.hide();
  
  //       // Odstránenie všetkých checkbox vrstiev patriacich do tohto tabu
  //       item.geoJson.forEach((_, rowIndex) => {
  //         const checkboxLayerName = `${tabName}-checkbox-${rowIndex}`;
  //         window.emitter.emit("removeRenderedFeature", "bothByLayerName", checkboxLayerName);
  //       });

  //     // Informovanie podkomponentu o čistení stavov checkboxov
  //     if (this.attributeTableTabsRef) {
  //       this.attributeTableTabsRef.clearCheckboxStatesForTab(tabName);
  //     }
  
  //       const closedTabIndex = this.state.items
  //         .map((e) => (e.alias ? e.alias : e.name))
  //         .indexOf(name);
  
  //       const newActiveTabIndex =
  //         closedTabIndex === this.state.items.length - 1
  //           ? closedTabIndex - 1
  //           : closedTabIndex;
  //       if (closedTabIndex === -1) return;
  
  //       this.setState(
  //         {
  //           items: this.state.items.filter((item) => {
  //             const itemName = item.alias ? item.alias : item.name;
  //             return tabName !== itemName;
  //           }),
  //         },
  //         () => {
  //           window.disableParcelClick = false;
  //           if (this.state.items.length === 0) {
  //             this.setState({ visible: false });
  //             window.emitter.emit("attributeTableResize", 0);
  //           } else {
  //             this.onTabClick(newActiveTabIndex);
  //           }
  //         }
  //       );
  //     }
  //   });
  // };

  onClose = () => {
    this.setState({ visible: false, items: [], savedItems: [] });
    window.emitter.emit("attributeTableResize", 0);
    // this.vectorLayer.getSource().clear();

    // Pošli signalizáciu na vymazanie stavov checkboxov v AttributeTableTabs
    if (this.attributeTableTabsRef) {
      this.attributeTableTabsRef.resetCheckboxStates();
    }

    // Získanie všetkých vrstiev z mapy a ich odstránenie, ak obsahujú 'checkbox'
    const layers = [...window.map.getLayers().getArray()];

    layers.forEach((layer) => {
      const name = layer.get("name");
      if (name && name.includes("checkbox")) {
        window.map.removeLayer(layer);
      }
    });
    
    window.emitter.emit(
      "removeRenderedFeature",
      "bothBySource",
      null,
      "filter"
    );
    window.emitter.emit(
      "removeRenderedFeature",
      "bothBySource",
      null,
      "kn"
    );
    window.emitter.emit("removeRenderedFeature", "bothBySource", null, "uri");
    window.emitter.emit("removeRenderedFeature", "bothBySource", null, "esri");
    // window.emitter.emit(
    //   "removeRenderedFeature",
    //   "byLayerName",
    //   "myGeometry",
    //   null
    // );
    window.emitter.emit("resetMyGeometry");
    window.emitter.emit("removeRowHighlight");
    window.popup.hide();
  };

  onHeaderClick = (evt, layerName, column, layerSource) => {
    const headerName = column.originKey;
    const isSortable = layerSource !== "uri" && layerSource !== "kn";
    var evtClone = Object.assign({}, evt);

    const menu = isSortable ? (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          onMenuItemClick={(key) => {
            this.onHeaderMenuItemClick(key, layerName, headerName);
          }}
          autoY={true}
          autoX={true}
        >
          <MenuItem
            className="sc-floating-menu-toolbox-menu-item"
            key="sc-floating-menu-asc"
          >
            <FloatingMenuItem
              imageName={"sortAscAz"}
              label="Zoradiť vzostupne"
            />
          </MenuItem>
          <MenuItem
            className="sc-floating-menu-toolbox-menu-item"
            key="sc-floating-menu-desc"
          >
            <FloatingMenuItem
              imageName={"sortDescAz"}
              label="Zoradiť zostupne"
            />
          </MenuItem>
        </FloatingMenu>
      </Portal>
    ) : null;

    ReactDOM.render(menu, document.getElementById("portal-root"));
  };

  
  onRowClick = (evt, item, rowIndex) => {

    const feature = item.geoJson[rowIndex];

    // Kontrola, či feature má geometriu
    if (!feature || !feature.getGeometry || !feature.getGeometry()) {
      console.warn("Feature nemá geometriu. Kliknutie je zakázané.");
      return;
    }
    window.emitter.emit("removeRenderedFeature", "allHighlights");
    window.emitter.emit("highlightOnMap", feature, item["name"]);
    window.emitter.emit("closePopup");

    // row coloring
    var evtClone = Object.assign({}, evt);
    var parentID = evt.target.parentElement.id;

    let isHighlighted = false;
    var tabRow0 = document.getElementById(parentID).getElementsByClassName("td");

    for (let i = 0; i < tabRow0.length; i++) {
      if (tabRow0[i].classList.contains('highlight-row')) {
        isHighlighted = true;
        break;
      }
    }

    if (isHighlighted) {

      window.emitter.emit("removeRenderedFeature", "allHighlights");
      // first all rows to transparent
      var tabRows_transparent = document.getElementsByClassName("tr"),
        index_t = tabRows_transparent.length;
      while (index_t--) {
        tabRows_transparent[index_t].className = "tr transparent-color";
      }
      // all rows to white color
      var tabRows_white = document.getElementsByClassName("td"),
        index_w = tabRows_white.length;
      while (index_w--) {
        tabRows_white[index_w].className = "td white-color";
      }
    } else {
      // first all rows to transparent
      var tabRows_transparent = document.getElementsByClassName("tr"),
        index_t = tabRows_transparent.length;
      while (index_t--) {
        tabRows_transparent[index_t].className = "tr transparent-color";
      }
      // all rows to white color
      var tabRows_white = document.getElementsByClassName("td"),
        index_w = tabRows_white.length;
      while (index_w--) {
        tabRows_white[index_w].className = "td white-color";
      }
      // finally the parent of the clicked element in color
      var tabRow = document.getElementById(parentID).getElementsByClassName("td"),
        index_r = tabRow.length;
  
      while (index_r--) {
        tabRow[index_r].className = "td highlight-row";
      }
    }

    const menu = (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          onMenuItemClick={(key) => {
            this.onRowMenuItemClick(key, item, rowIndex);
          }}
          autoY={true}
          autoX={true}
        >
          <MenuItem
            className="sc-floating-menu-toolbox-menu-item"
            key="sc-floating-menu-zoom"
          >
            <FloatingMenuItem imageName={"zoom"} label="Priblížiť na objekt" />
          </MenuItem>
          {/* {window.activeTool !== "resultManagement" ? ( */}
          <MenuItem
            className="sc-floating-menu-toolbox-menu-item"
            key="sc-floating-menu-save"
          >
            <FloatingMenuItem imageName={"save"} label="Uložiť ako výsledok" />
          </MenuItem>
          {/* ) : null} */}
        </FloatingMenu>
      </Portal>
    );
    ReactDOM.render(menu, document.getElementById("portal-root"));
  };

  onRowMenuItemClick = (key, item, rowIndex) => {
    if (key === "sc-floating-menu-zoom") {
      helpers.zoomToFeature(item.geoJson[rowIndex]);
    }
    if (key === "sc-floating-menu-save") {
      this.addRowToPreviousResults(key, item, rowIndex);
    }
  };

  // ukladanie jedneho riadku z tabulky medzi predosle vysledky
  addRowToPreviousResults = (key, item, rowIndex) => {
    // this.vectorsRemoving();
    let oneRowItem = {
      ...item,
    };

    let uniqueFilterName = "";

    if (oneRowItem["layerSource"] === "kn") {

      uniqueFilterName = vHelpers.getUniqueName(
        oneRowItem["tabName"],
        null,
        vHelpers.extractUsedFilterNames(window.config.storageKeyFilterResults)
      );

    } else {

      uniqueFilterName = vHelpers.getUniqueName(
        (oneRowItem.geoJson[rowIndex].id_.startsWith("Filter_")
          ? ""
          : "Filter_") + oneRowItem.geoJson[rowIndex].id_,
        null,
        vHelpers.extractUsedFilterNames(window.config.storageKeyFilterResults)
      );
    }

    oneRowItem["key"] = helpers.getUID();
    oneRowItem["geoJson"] = [oneRowItem.geoJson[rowIndex]];
    oneRowItem["name"] = uniqueFilterName;
    oneRowItem["rowIndex"] = rowIndex;
    oneRowItem["id"] = oneRowItem.geoJson[0].id_;
    oneRowItem["ol_uid"] = oneRowItem.geoJson[0].ol_uid;
    oneRowItem["api_url"] = oneRowItem.geoJson[0].api_url;
    // oneRowItem["alias"] = oneRowItem.geoJson[0].id_;

    oneRowItem["name"] =
      oneRowItem["layerSource"] === "uri"
        ? oneRowItem["tabName"]
        : oneRowItem["name"];

    if (oneRowItem["layerSource"] === "esri") {
      oneRowItem["esri_id"] = oneRowItem.geoJson[0].values_.esri_id;
      oneRowItem["query"] = "";
    }
    if (oneRowItem["layerSource"] === "kn") {
      oneRowItem["api_url"] = undefined;
      oneRowItem["tabName"] = vHelpers.getUniqueName(
        oneRowItem["name"],
        "",
        vHelpers.extractUsedFilterNames(window.config.storageKeyFilterResults)
      );;
    }

    this.setState((prevState) => ({
      savedItems: [oneRowItem, ...prevState.savedItems],
    }), () => {
      helpers.showMessage(
        "Oznámenie",
        "Vybraný objekt je teraz dostupný v Manažmente výsledkov.",
        helpers.messageColors.green,
        5000,
      );
    });

    // if (item.layerSource !== "uri") {
    //   window.emitter.emit(
    //     "openAttTab",
    //     window.config.geoserverUrl,
    //     oneRowItem.layerName,
    //     null, // cql
    //     oneRowItem.name,
    //     false, // checkbox for save
    //     oneRowItem.id, // id - for addTableRow
    //     "filter", // source
    //     oneRowItem.alias,
    //     true
    //   );
    // }
  };

  //ascending
  onHeaderMenuItemClick = (key, layerName, headerName) => {

    if (key === "sc-floating-menu-asc") {
      let newItem = this.state.items.filter((item) => {
        return item.name === layerName;
      })[0];

      newItem.sortFields = headerName + " A";
      this.getData_longGeometry(false, newItem);
    } else if (key === "sc-floating-menu-desc") {
      let newItem = this.state.items.filter((item) => {
        return item.name === layerName;
      })[0];
      newItem.sortFields = headerName + " D";
      this.getData_longGeometry(false, newItem);
    }
  };

  onLoadMoreClick = (item) => {
    if (item.maxRecords === item.total) return;

    const nextNumRecords = item.maxRecords + this.numRecordsToPull;
    if (nextNumRecords > item.total) item.maxRecords = item.total;
    else item.maxRecords = nextNumRecords;

    this.getTable_longGeometry(false, item);
  };
  onLoadAllClick = (item) => {
    if (item.maxRecords === item.total) return;
    item.maxRecords = item.total;
    this.getData_longGeometry(false, item);
  };
  render() {
    return (
      <div
        className={
          this.state.visible
            ? "sc-attribute-table-container sc-noselect"
            : "sc-hidden"
        }
        style={{ maxWidth: this.state.mapWidth }}
      >
        {/* <LoadingScreen key={helpers.getUID()} visible={this.state.isLoading} spinnerSize={60} /> */}
        <Resizable
          handleClasses={{
            right: "sc-hidden",
            left: "sc-hidden",
            bottom: "sc-hidden",
            bottomRight: "sc-hidden",
            topRight: "sc-hidden",
            bottomLeft: "sc-hidden",
            topLeft: "sc-hidden",
            top: "sc-attribute-handle",
          }}
          onResize={this.onResize}
          onResizeStart={this.onResizeStart}
          onResizeStop={this.onResizeStop}
          maxHeight={400}
          maxWidth={this.state.mapWidth}
          ref={(c) => {
            this.resizable = c;
          }}
          defaultSize={{
            // width: 320,
            height: 0,
          }}
        >
          <AttributeTableTabs
            ref={(ref) => { this.attributeTableTabsRef = ref; }}
            items={this.state.items}
            height={this.state.height}
            width={this.state.mapWidth}
            tabIndex={this.state.tabIndex}
            onTabClose={this.onTabClose}
            onTabClick={this.onTabClick}
            onHeaderClick={this.onHeaderClick}
            onRowClick={this.onRowClick}
            onLoadMoreClick={this.onLoadMoreClick}
            onLoadAllClick={this.onLoadAllClick}
            isLoading={this.state.isLoading}
          />
          <div
            className="sc-attribute-table-closer"
            title="Zatvoriť všetky atribútové tabuľky"
            onClick={this.onClose}
          >
            {/* <img src={images["close.png"]} alt="close table" /> */}
            <FontAwesomeIcon
              className="faCircleXmark-table-icon"
              icon={faCircleXmark}
            />
          </div>
        </Resizable>
      </div>
    );
  }
}

export default AttrbuteTable;
